export const BENEFITS = [
	{ benefitText: '60 minut treningu personalnego' },
	{ benefitText: 'indywidualne podejście do każdej podopiecznej' },
	{ benefitText: 'motywację i wsparcie na każdym etapie współpracy' },
	{ benefitText: 'naukę poprawnej i bezpiecznej techniki' },
	{ benefitText: 'skuteczne i urozmaicone ćwiczenia dopasowane do Ciebie' },
	{ benefitText: 'pracę nad postawą ciała i redukcją bólu kręgosłupa' },
	{ benefitText: 'monitorowanie postępów i stałą kontrolę efektów' },
	{ benefitText: 'poprawę komfortu codziennego życia i samopoczucia' },
];

export const FAQ = [
	{
		question: 'Czy mogę przyjść, jeśli nigdy wcześniej nie ćwiczyłam?',
		answers: [
			'Tak. Treningi są dostosowane również dla osób początkujących. Wszystko tłumaczę krok po kroku, a tempo dopasowuję do Twojego poziomu i samopoczucia. Nie musisz mieć doświadczenia ani kondycji, żeby zacząć.',
		],
	},
	{
		question: 'Jak wygląda pierwszy trening?',
		answers: [
			'Pierwsze spotkanie zaczynamy rozmową o Twoich celach, samopoczuciu i ewentualnych dolegliwościach.',
			'Następnie wykonuję testy diagnostyczne, aby określić Twoją sprawność, mobilność oraz ewentualne ograniczenia ruchowe.',
			'Na tej podstawie dobieram odpowiednie ćwiczenia i przechodzimy do treningu wprowadzającego, podczas którego uczysz się poprawnej techniki ćwiczeń.',
		],
	},
	{
		question: 'Gdzie odbywają się treningi?',
		answers: [
			'Treningi odbywają się w kameralnym Studiu Sportu Dual. To spokojna, komfortowa przestrzeń bez tłumów, dzięki czemu możesz czuć się swobodnie i skupić na treningu.',
		],
	},
	{
		question: 'Czy mogę przyjść z koleżanką?',
		answers: [
			'Tak. Możesz zapisać się na trening w parze lub w mini grupie 3-osobowej. To świetna opcja, jeśli czujesz się pewniej ćwicząc z kimś bliskim.',
		],
	},
	{
		question: 'Ile trwa trening lub konsultacja?',
		answers: ['Trening jak i konsultacja trwają 60 minut.'],
	},
	{
		question: 'Czy mogę zmienić termin treningu?',
		answers: [
			'Tak. Termin treningu można zmienić, informując odpowiednio wcześniej. Staram się być elastyczna i dopasować grafik do Twoich możliwości.',
		],
	},
	{
		question: 'Czy trening pomoże mi przy bólu pleców lub złej postawie?',
		answers: [
			'Tak. Treningi pomagają poprawić postawę ciała, wzmocnić osłabione mięśnie oraz zmniejszyć dolegliwości bólowe. Ćwiczenia dobieram bezpiecznie i indywidualnie.',
		],
	},
	{
		question: 'Po jakim czasie zobaczę efekty?',
		answers: [
			'Pierwsze efekty w postaci lepszego samopoczucia i większej sprawności pojawiają się już po kilku treningach.',
			'Widoczne efekty sylwetkowe zależą od regularności i zwykle pojawiają się po kilku tygodniach.',
		],
	},
	{
		question: 'Co zabrać na pierwszy trening?',
		answers: [
			'Wystarczy wygodny strój sportowy, obuwie na zmianę oraz woda. Cały sprzęt treningowy jest dostępny na miejscu.',
		],
	},
	{
		question: 'Jak zapisać się na pierwszy trening?',
		answers: [
			'Wystarczy skontaktować się przez formularz na stronie, wiadomość lub telefon. Ustalimy dogodny termin i dopasujemy odpowiednią formę treningu.',
		],
	},
];
